(function () {
  'use strict';

  const { iman } = window.Universe;

  /* -- DiagonalText -------------------------------------------------- */

  class DiagonalText {
    constructor(section) {
      if (!section) return;

      this.init(section);
    }

    resize() {
    }

    destroy() {
      if (this.DOM) {
        this.occupiedHeights = 0;
        this.DOM = undefined;
      }
    }

    init(section) {
      this.DOM = {};
      this.DOM.section = section;
      this.DOM.container = this.DOM.section.querySelector('.js-diagonal-texts-container');
      this.DOM.items = this.DOM.section.querySelectorAll('.js-diagonal-text-item');

      // Rotation and container padding handled by CSS
    }
  }

  /* -- DiagonalTexts ------------------------------------------------- */

  class DiagonalTexts {
    constructor() {
      this.init();
    }

    setup() {
      for (let i = 0; i < this.DOM.sections.length; i++) {
        this.instances.push(new DiagonalText(this.DOM.sections[i]));
      }
    }

    resize() {
      if (this.DOM) {
        for (let i = 0; i < this.instances.length; i++) {
          this.instances[i].resize();
        }
      }
    }

    reinit() {
      this.destroy();
      this.init();
    }

    destroy() {
      if (this.DOM) {
        for (let i = 0; i < this.instances.length; i++) {
          this.instances[i].destroy();
        }
        this.instances = [];
        this.DOM = undefined;
      }
    }

    init(container = document) {
      const sections = container.querySelectorAll('.js-diagonal-texts');

      if (sections.length) {
        this.DOM = {};
        this.DOM.sections = sections;

        this.instances = [];

        this.setup();
      }
    }
  }

  /* -- Init ---------------------------------------------------------- */

  function init() {
    if (!iman.get('diagonalTexts')) {
      iman.add('diagonalTexts', new DiagonalTexts());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.Universe.DiagonalTexts = DiagonalTexts;
})();
